module.exports = __webpack_public_path__ + "img/Flag_of_Guernsey.c606819c.svg";